import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransactionHistoryService {

  constructor(private http : HttpClient) { }

  getAllTransactions(){
    return this.http.get(`${environment.apiUrl}/transactions`)
  }
}
